import React from 'react';
import './Pharmacy.css'; // Make sure to update the CSS accordingly

const pharmacyData = {
  inventory: [
    { id: 1, medicine: 'Paracetamol', quantity: 120, expiryDate: '2026-03-10', supplier: 'HealthCorp', pricePerUnit: 0.10 },
    { id: 2, medicine: 'Amoxicillin', quantity: 80, expiryDate: '2025-12-15', supplier: 'PharmaPlus', pricePerUnit: 0.50 },
    { id: 3, medicine: 'Ibuprofen', quantity: 50, expiryDate: '2025-10-01', supplier: 'MediSupply', pricePerUnit: 0.20 },
    { id: 4, medicine: 'Metformin', quantity: 100, expiryDate: '2026-05-20', supplier: 'HealthCorp', pricePerUnit: 0.30 },
    { id: 5, medicine: 'Amlodipine', quantity: 70, expiryDate: '2026-01-30', supplier: 'PharmaPlus', pricePerUnit: 0.40 },
  ],

  recentOrders: [
    { orderId: 'ORD001', medicine: 'Paracetamol', quantity: 100, orderDate: '2025-06-01', status: 'Delivered' },
    { orderId: 'ORD002', medicine: 'Ibuprofen', quantity: 60, orderDate: '2025-06-10', status: 'Pending' },
    { orderId: 'ORD003', medicine: 'Amoxicillin', quantity: 40, orderDate: '2025-06-12', status: 'Delivered' },
    { orderId: 'ORD004', medicine: 'Metformin', quantity: 50, orderDate: '2025-06-15', status: 'Shipped' },
  ],

  suppliers: [
    { name: 'HealthCorp', contact: 'healthcorp@example.com', phone: '+1 555 123 4567', rating: 4.7 },
    { name: 'PharmaPlus', contact: 'pharmaplus@example.com', phone: '+1 555 987 6543', rating: 4.5 },
    { name: 'MediSupply', contact: 'medisupply@example.com', phone: '+1 555 111 2222', rating: 4.3 },
  ],
};

const Pharmacy = () => {
  return (
    <div className="pharmacy-container">
      <h3>Pharmacy Inventory</h3>
      <table className="pharmacy-table">
        <thead>
          <tr>
            <th>Medicine</th>
            <th>Quantity</th>
            <th>Expiry Date</th>
            <th>Supplier</th>
            <th>Price Per Unit ($)</th>
          </tr>
        </thead>
        <tbody>
          {pharmacyData.inventory.map(item => (
            <tr key={item.id}>
              <td>{item.medicine}</td>
              <td>{item.quantity}</td>
              <td>{item.expiryDate}</td>
              <td>{item.supplier}</td>
              <td>{item.pricePerUnit.toFixed(2)}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <h3>Recent Orders</h3>
      <table className="pharmacy-table">
        <thead>
          <tr>
            <th>Order ID</th>
            <th>Medicine</th>
            <th>Quantity</th>
            <th>Order Date</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {pharmacyData.recentOrders.map(order => (
            <tr key={order.orderId}>
              <td>{order.orderId}</td>
              <td>{order.medicine}</td>
              <td>{order.quantity}</td>
              <td>{order.orderDate}</td>
              <td>{order.status}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <h3>Suppliers</h3>
      <table className="pharmacy-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Contact Email</th>
            <th>Phone</th>
            <th>Rating</th>
          </tr>
        </thead>
        <tbody>
          {pharmacyData.suppliers.map((supplier, idx) => (
            <tr key={idx}>
              <td>{supplier.name}</td>
              <td>{supplier.contact}</td>
              <td>{supplier.phone}</td>
              <td>{supplier.rating}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Pharmacy;
